import { Toggler } from '@hh.ru/magritte-ui-tree-selector/strategy/types';

/**
 * Переключает элемент в наборе.
 */
const toggle: Toggler = (set, item, state) => {
    if (state && !set.has(item)) {
        set.add(item);
        return true;
    } else if (!state && set.has(item)) {
        set.delete(item);
        return true;
    }
    return false;
};

export default toggle;
